import { asScaled } from '../utils';
const tabLayout = {
    // 间距
    spacing: 20,
    // 高度
    height: 44,
    // 条目下部滑块
    widgetWidth: 24,
    widgetHeight: 3,
    widgetBottom: 4,
    // 遮罩宽度
    maskWidth: 32,
    // 尾标间距
    suffixMargin: 6,
    suffixIconFontsize: 8
};
const tabLayoutScaled = asScaled(tabLayout);
export const tab = {
    scaled: tabLayoutScaled,
    unscaled: tabLayout
};
